import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth52: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M47.2,86.2h53.5c-28.3-47.9-53.5,0-53.5,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '136.8 97.4 137.6 101.2 137.6 103.3 136.9 109.3 135.5 114.5 14.1 114.5 13.4 111.5 13.4 108.1 14.1 102.1 14.2 99.1 15.4 94.5 135 94.5 136.8 97.4',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.5,123.5c-27.2-21.5,2.1-40,2.1-40l5,6.1,3.5,5,2.6,6.2-.2,7.2-1.9,6.6-3,3.3-8.2,5.5h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22,84.2c36.8,21.9-3.2,42-3.2,42l-4.1-6.6-1.3-8.1v-5.4s.8-7,.8-7l1.2-4.6,2.6-4.6,3.9-5.8h.1Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M135.2,111.5l.6-.7,1.3-7.4-.3-3.9-2.2-5.5-3.2-5.9-4.3-4.9-4.9-4.6-6.2-3.7-6.2-4.3-6.6-4.6-7-2.9-6.6-2.2-11-1.2-12.9.4-7.7,1.2-7,2.2-7.5,3.2-6.4,3.5-5.6,4.6-5.6,4.5-5.4,5.3-5.3,9.7-1.6,12.2c74.5-24.9,121.5,5,121.5,5h.1Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M135.3,111.4l.3,1.9-4.5,5.9-9.1,6.2-9.4,5.2-8.3,6.3-7.5,8.4-8.1,5.6-8,3.8-10.5,2.8h-11.2s-5.4-1.4-5.4-1.4l-6.8-2.4-6.3-3.6-8-7.6-5.1-5.3-7.2-7.7-3.7-5.2-2.6-7.3-.3-10.5c74.7-25.1,121.5,5,121.5,5h.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.3,149.8c-8.6,4.5-17.6,8.2-27.2,7.6s-22.2-6.5-29.7-14.7-5-6.5-8.1-8.9c-9.4-7.4-12.3-18.3-11.2-29.7s4.7-16.3,11-23c12.7-13.5,29-20.2,47.3-20.7s28.8,3.3,41.1,13.1c6,4.8,12.8,8.1,17.5,14.5,6.2,8.6,8.3,18.4,3.2,28.3-9.4,9.9-22.5,12.2-31.8,22-3.8,4-6.7,8.6-12.1,11.4Z',
			},
		},
	},
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '17.2 50.4 21.3 43.5 28 35.5 33.9 30.7 41.8 26.6 48.5 24.2 69.7 24.6 92 24.6 117.1 24.6 127.5 27.3 135.5 30.3 140.3 35.8 141.7 41.3 141.9 51.5 17.2 50.4',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M140.3,68.3c-55.5,5.4-5.1,32.3-5.1,32.3l3.4-14.6,1.7-17.6h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12.8,96.3l-.7-5.3-.5-9.8v-8.6s1.2-7.7,1.2-7.7c51.3,10.2,0,31.4,0,31.4Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M61.5,98A13.4,13.4 0 0 1 88.3,98A13.4,13.4 0 0 1 61.5,98Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M115.7,145.2c-43,26.1-88.6,0-88.6,0l-5-11.7c59,33.4,100.5,0,100.5,0l-6.9,11.7Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.5,133.5c-29.5-25.2-20.8-108.8-20.8-108.8h13.5s7.3,1.6,7.3,1.6l7.8,2.1,5.3,2.3,4.1,4.4,1.6,4.8v24.5s-1.1,10.3-1.1,10.3l-1.1,7.3-1.6,9.2-2.1,10.3-2.3,8.9-2.1,8-3.4,6.4-5,8.7h0Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.3,133.7C59.1,109.2,58.9,24.9,58.9,24.9h-5.3s-7.6,1.4-7.6,1.4l-8.7,2.7-8.9,7.1-6.2,7.3-4.4,8.2-4.4,8-2.3,10.5v16s1.1,11.9,1.1,11.9l1.6,8,3.4,13.5,4.8,14,.3.2Z',
			},
			[ToothSurface.PalatalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M122.4,133.4c-48.7,33.7-100.5,0-100.5,0l-4.8-14-3.4-13.5-1.6-8-1.1-11.9v-16s2.3-10.5,2.3-10.5l4.4-8,6.2-10.4,4.4-5.2,8.9-7.1,8.7-2.7,7.6-1.4h61.8s7.3,1.6,7.3,1.6l7.8,2.1,5.3,2.3,4.1,4.4,1.6,4.8v24.5s-1.1,10.3-1.1,10.3l-1.1,7.3-1.6,9.2-2.1,10.3-2.3,8.9-2.1,8-8.5,15.1h-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M129.5,121.2c-10.2,10.1-21.5,18.1-34.6,23.6-30,12.6-58.7,1.3-77.6-24-4-13.1-4.8-26-5.7-39.5-1.2-17.6,5-33.6,17.8-46.1,17.4-16.9,40.5-7.1,55.2-8.6,16-1.6,46.3-3.5,53.7,7.9,3.6,5.5,3.6,12.7,3.1,19-1.8,23-4.9,44.8-12,67.7Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M42.7,420.9h59.1c-29.2-119.1-59.1,0-59.1,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M140.4,454.3l-2.4-28.9c-45.7,13.2,2.4,28.9,2.4,28.9Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M8.6,426.9c54.1,7.7,4.7,29.4,4.7,29.4l-4.7-16.2v-13.2s0,0,0,0Z',
			},
			[ToothSurface.Incisal]: {
				type: ToothSurfaceDataType.POLYGON,
				data: '19.1 467.9 25.9 476 33.4 482 46.3 485.6 56.6 486.7 72.8 486.9 85.9 487.7 98.7 487.5 111.7 486.7 125.8 483.5 133.2 478.9 138.5 471.7 140.2 463.1 16.5 463.1 19.1 467.9',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.7,365.2l-1-9.8c-44.2-36.3-92.1.6-92.1.6l-1.3,9.7c57.6-34.3,94.4-.5,94.4-.5h0Z',
			},
			[ToothSurface.Class_4Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M117.7,365.2l6.4,9,5.6,10.2,2.5,8.8,3.2,12.4,2.2,12.2,2.1,12.7,1.5,11.9v21.8s-1.5,5-1.5,5l-1.8,4.3-3.4,4-3.5,3.7-5,2.5-6.6,2.2s-8,1.5-8,1.6h-9.7c-5.7-63.3,16-122.3,16-122.3Z',
			},
			[ToothSurface.Class_4Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.3,365.6c19.6,41.2,25.9,120.6,25.9,120.6l-6.1-.7-7.8-3.1-9.4-6.9-5.4-5.7-6.6-10.6-3.4-10.8-1.9-8s-.4-8.8-.3-8.8v-16.3s.7-7.5.7-7.5l1.5-9.7,2.8-10.8,3.8-8.5,4.2-8.8,2-4.2v-.2Z',
			},
			[ToothSurface.BuccalSurface]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M23.3,365.6c57.9-34.4,94.4-.5,94.4-.5l.8,2.2,4.9,6.8,5.5,9.2,4.1,12.1,2.4,10.6,3.1,17.7,1.7,11.3.5,17.2.3,11.6-1.9,8.9-6.6,7.8-7.2,3.8-11.1,2.6-11.8,1.4h-11.3s-34.4-.9-34.4-.9l-11.3-1.5-9.7-2.7-5.1-2.9-8.2-7.7-5.9-9.5-4.1-8.5-4.1-15.5-.3-11.4.5-8.7.3-10.9,1.5-11.3,3.8-11.1,2.4-5.8,4.8-9.2,2-4.9v-.2Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M98.4,488l-42.9-.8c-9.1-.2-18.3-2.8-25.4-8.2-26.4-20.2-24.5-60-16.8-90.7s2.1-5.6,3.5-7.2c27.2-29.1,66-41.3,98.1-13.8,7.3,6.2,13,12.6,15.7,22.3,5.6,20.2,9.1,41,9.7,62.1l-.2,11.9c-.2,10.2-6.8,18.1-16.5,20.9s-16.1,3.7-25.1,3.5Z',
			},
		},
	},
};
